<div class="container-fluid mt-4">
  <chapps-header [label]="Localization.Dashboard">
    <i icon class="fas fa-building"></i>
  </chapps-header>
  <hr>
  <div class="row mt-4">
    <div class="col-12 col-xl-6">
      <app-dashboard-notifications-card></app-dashboard-notifications-card>
    </div>
    <div class="col-12 col-xl-6">
      <app-dashboard-messages-card></app-dashboard-messages-card>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <app-dashboard-notifications-per-building-card></app-dashboard-notifications-per-building-card>
    </div>
  </div>
</div>
